module.exports = "<ui-view></ui-view>\n<ng2-toasty [position]=\"'top-right'\"></ng2-toasty>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main